<div class="Courses-card">
    <div class="top-box">
      <div class="img">
        <img [src]="course.logo_link" alt="{{course.course_name.split('.')[1]}}" loading="lazy">
      </div>
    </div>
    <div class="content-box">
      <div class="content-in">
        <div class="head">
          <h2 *ngIf="course.course_name.includes('.')">
            {{course.course_name.split('.')[1]}}</h2>
            <h2 *ngIf="!course.course_name.includes('.')">{{course.course_name}}</h2>
        </div>
        <div class="mid-content">
          <ul>
            <li>
                <p [innerHTML]="course.speciality | safeHtml"></p>
            </li>
          
          </ul>
        
        </div>
      </div>
    </div>
    <div class="buy-box">
      <div class="buy-in" *ngIf="!course.display_only_one">
        <div class="price">
          <h4>{{course.offer_price|currency}}</h4>
          <p *ngIf="course.actual_price != course.offer_price">
            <del>{{course.actual_price|currency}}</del>
          </p>
        </div>
        <div class="butns">
          <button mat-raised-button (click)="buynow(course)">Buy Now <i class="bi bi-arrow-right"></i>
          </button>
          <button mat-raised-button (click)="details(course)" class="btn-2">Details</button>
        </div>
      </div>
      <div class="buy-in" *ngIf="course.display_only_one">
        <div class="price">
          <h4>{{course.offer_price|currency}}</h4>
          <p *ngIf="course.actual_price != course.offer_price">
            <del>{{course.actual_price|currency}}</del>
          </p>
        </div>
        <div class="butns">
          <button mat-raised-button (click)="buynow(course)"> Course Structure & Discount
          </button>
        </div>
      </div>
    </div>
  </div>